import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { AssignUserModal } from "..";
import { useAssignedIconProps } from "../hooks/useAssignedIconProps";

type Props = {
  onSave?: (objectIds: string[]) => void;
};

export const AssignedUsersIcon = observer((props: Props) => {
  const t = useTranslation();
  const [reload, setReload] = useState<number>(0);
  const [openUserAssignModal, setOpenAssignModal] = useState(false);
  const { iconStyle, tooltipProps } = useAssignedIconProps();

  return (
    <div>
      <Tooltip
        placement="top"
        title={t(tooltipProps.text, tooltipProps.translation)}
      >
        <Icon
          icon="fa:user"
          style={iconStyle}
          color={tooltipProps.color}
          onClick={() => setOpenAssignModal(true)}
        />
      </Tooltip>
      <AssignUserModal
        open={openUserAssignModal}
        onCancel={() => setOpenAssignModal(false)}
        onOk={(objectIds: string[]) => {
          setOpenAssignModal(false);
          setReload(reload + 1);
          props.onSave?.(objectIds);
        }}
      />
    </div>
  );
});
